import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface IDescriptionEditorProps {
    value: string;
    onUpdate: (field: 'description', value: string) => void;
}

export default function DescriptionEditor({ value = '', onUpdate }: IDescriptionEditorProps) {
    const { t } = useTranslation();
    return (
        <TextField
            fullWidth
            multiline
            rows={4}
            label={t('common:description')}
            value={value}
            placeholder={'-'}
            onChange={(e) => onUpdate('description', e.target.value)}
        />
    );
}
